// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"b94a4e79","297":"b94a4e79","621":"928e12fa","818":"837cfaee","869":"b94a4e79","953":"b94a4e79"}[chunkId] + ".chunk.css";
};